import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const SelectIndividualMemberData = {
    columns: [
        {
            name: "",
            fieldName: "isSelectedRecord",
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowEdit: false,
            },
            allowShort: false,
        },
        // {
        //     name: "First Name",
        //     fieldName: "firstName",
        //     allowShort: false,
        //     colType: GridColumnType.Text,
        // },
        // {
        //     name: "Last Name",
        //     fieldName: "lastName",
        //     allowShort: false,
        //     colType: GridColumnType.Text,
        // },
        {
            name: "Display Name",
            fieldName: "displayName",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "companyName",
            fieldName: "companyName",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "EXCO Position",
            fieldName: "excoPosition",
            allowShort: false,
        },
        {
            name: "Join Date",
            fieldName: "joinDate",
            colType: GridColumnType.DATEtime,
            allowShort: false,
        },

        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: false,
            },
            allowShort: false,
        },
    ],
    allowEdit: false,
    isRowSelectable: true,
    hasChildGridTable: false,
    gridStyle: {
        tableClass: "border-table-simple",
    },
};